import { AppConfig } from './app-config.token';

const DEFAULT_MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
const DEFAULT_UPLOAD_TIMEOUT_MS = 90_000;

function envNumber(raw: string | undefined, fallback: number): number {
  if (raw == null || raw === '') return fallback;
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export const runtimeConfig: AppConfig = {
  appName: import.meta.env.VITE_APP_NAME,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  environment: (import.meta.env.VITE_ENV ?? 'dev') as AppConfig['environment'],
  enableI18n: false,
  announcementBanner: '',
  auth: {
    tokenStorageKey: import.meta.env.VITE_APP_NAME,
    authHeader: 'Authorization',
    gatewayLoginUrl: '',
    tokenExchangeUrl: '',
    msal: {
      clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
      tenantId: import.meta.env.VITE_MSAL_TENANT_ID,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: '',
      apiScopes: [import.meta.env.VITE_MSAL_API_SCOPES],
    },
  },
  http: {
    timeoutMs: 25_000,
    uploadTimeoutMs: envNumber(
      import.meta.env.VITE_HTTP_UPLOAD_TIMEOUT_MS,
      DEFAULT_UPLOAD_TIMEOUT_MS,
    ),
  },
  staff: {
    maxUploadBytes: envNumber(
      import.meta.env.VITE_STAFF_MAX_UPLOAD_BYTES,
      DEFAULT_MAX_UPLOAD_BYTES,
    ),
  },
};
